import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRASlideshowComponent } from '@ibe.components/common/slideshow/slideshow.indra.component';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Observable, Subscription } from 'rxjs';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import * as _ from 'lodash';
import {
	ANCILLARY_GROUP_SEAT_RESERVATION_LIST,
	TRANSLATION_ANCILLARY_GROUP,
	// BRAND_DESRIPTION_TOP_EXECUTIVE,
	// BRAND_DESRIPTION_EXECUTIVE,
	ANCILLARY_GROUP_DEPORTEES_LIST,
	ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST,
	SSR_CODE_UNACCOMPANIED_MINOR,
	SSR_CODE_FREE_SEAT_RESERVATION,
	PAX_TYPE_INFANT_CODE,
	SEATMAP_SEAT_TYPE_STANDARD,
	SEATMAP_SEAT_TYPE_BUSINESS,
	SEATMAP_SEAT_TYPE_PREFERED,
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_TOP_EXECUTIVE,
	UNCONFIRMED_CODES, TRANSLATION_BOOKING_DETAILS_MODULE, TRANSLATION_ALT, SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { INDRATotalSummaryService } from '@ibe.services/total-summary.service';
import { PURCHASED_ANCILLARY_SEAT } from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import {INDRAAncillaryInfo} from '@ibe.models/pnr-data.indra.model.lib';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { AssetInfo } from '@ibe.models/asset-info.indra.model';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-details-seat',
	templateUrl: './details-seat.indra.component.html',
	styleUrls: ['./details-seat.component.scss']
})
export class INDRADetailsSeatComponent implements OnInit, OnDestroy
{


	flight: any;
	flightWithSegmentsOperatedByTAP: any;
	interlineFlights: any;
	flight$: Observable<any>;
	_hasEdit = true;
	flightIdentifier: string;

	galleryImages = [];

	passengers: INDRAPax[] = [];
	paxFareInfoFeatures = [];
	paxPurchaseFeatures = [];
	seatTypesToShow = [];
	hasLayover = false;
	seats = [];
	segments = [];
	LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.';
	LOCAL_TRANSLATION_DETAILED_SEAT = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsSeat.';

	hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
	hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
	hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
	IfAllPassengersAreChildren = false;
	// hasPreferredSeats = false;
	seatType = SEATMAP_SEAT_TYPE_STANDARD;
	hasIssuedTicket = true; // used for checking if PNR has issued ticket/s
	isFlagged: boolean = false;
	totalSummarySubscription: Subscription;
	
	isMYB: boolean = false;
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brand: string;
	
	hasTAPOperatedFlight: boolean = false;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private modalService: ModalService,
		protected bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		private bfmDataStorage: INDRABFMDataStorageService,
		private totalSummaryService: INDRATotalSummaryService,
		private ancillariesService: INDRAAncillariesService,
		public ancillaryCartService: INDRAAncillariesShoppingCartService,
		private bookingSearchService: INDRABookingSearchService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) { 
		if (this.router.url.includes('/my-bookings/')) this.isMYB = true;
		if (this.router.url.includes('/my-bookings/view/')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
	}


	ngOnInit() {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.flightWithSegmentsOperatedByTAP = this.bookingService.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(this.flightIdentifier);
		// const cabin = this.flightWithSegmentsOperatedByTAP.cabin;
		this.hasTAPOperatedFlight = this.flightWithSegmentsOperatedByTAP && 
			this.flightWithSegmentsOperatedByTAP.listSegment && 
			this.flightWithSegmentsOperatedByTAP.listSegment.length > 0 ? true : false;

		const hasPreferredSeats = this.bookingService.INDRA_hasAncillary(SSR_CODE_FREE_SEAT_RESERVATION, this.flightIdentifier);
		this.seats = (this.isBookingView || this.isReviewTTTCompletion) ? this.bookingService.INDRA_getIBESeatDetails(this.flight.idFlight.toString(), this.flightIdentifier) : this.bookingService.INDRA_getSeatDetails(this.flight.idFlight.toString(), this.flightIdentifier);
		this.seatTypesToShow=this.INDRA_getUniqueSeatDetails(this.flightIdentifier);
		this.brand = this.INDRA_getBrand();

		if (this.brand === BRAND_CODE_EXECUTIVE || this.brand ===  BRAND_CODE_TOP_EXECUTIVE) {
			this.seatType = SEATMAP_SEAT_TYPE_BUSINESS;
		} else {
			this.seatType = hasPreferredSeats ? SEATMAP_SEAT_TYPE_PREFERED : SEATMAP_SEAT_TYPE_STANDARD;
		}

		let defaultDescription = this.INDRA_getTranslation(`${TRANSLATION_BOOKING_DETAILS_MODULE + TRANSLATION_ALT}` + 'seatTypeStandard');
		this.galleryImages = [
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/1.jpg',
				description: defaultDescription
			},
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/2.jpg',
				description: defaultDescription
			},
			{	
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/4.jpg',
				description: defaultDescription
			},
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/5.jpg',
				description: defaultDescription
			},
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/6.jpg',
				description: defaultDescription
			},
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/7.jpg',
				description: defaultDescription
			},
			{
				path_url: SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT+'/8.jpg',
				description: '8'
			}
		];

		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.hasLayover = this.INDRA_checkIndirectFlight();
		this.seats = this.bookingService.INDRA_getSeatDetails(this.flight.idFlight.toString(), this.flightIdentifier);
		this.segments = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
		this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
		this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();
		this.interlineFlights = this.bookingService.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(this.flightIdentifier);
		let ineligibleOnSeatSelectionCount = 0;
		this.passengers.forEach(pax => {
			let ineligibleForSeatSelection = false;
			if (pax.prm) {
				let deporteePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type));
				let medicalAssistancePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type));
				let umnrPRM = pax.prm.filter(prmItem => SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type);
				let ineligiblePRMForSeatSelection = pax.prm.filter(prmItem => PURCHASED_ANCILLARY_SEAT.ineligibleSSR.includes(prmItem.type));

				if (deporteePRM.length > 0) {
					this.hasDeporteeFlag = true;
				}

				if (medicalAssistancePRM.length > 0) {
					this.hasMedicalAssistanceFlag = true;
				}

				if (umnrPRM.length > 0) {
					this.hasUMNRFlag = true;
				}

				// checking if passenger's prm is ineligible on seat selection..
				if (ineligiblePRMForSeatSelection.length > 0) {
					ineligibleForSeatSelection = true;
				}
			}

			// infant is also ineligible for seat selection..
			if (pax.typePax === PAX_TYPE_INFANT_CODE) {
				ineligibleForSeatSelection = true;
			}

			// checking if passenger's current purchased ancillaries for interline segments is ineligible on seat selection..
			if (!ineligibleForSeatSelection && this.interlineFlights.listSegment && this.interlineFlights.listSegment.length > 0) {
				let ineligibleSegmentCount = 0;
				this.interlineFlights.listSegment.forEach(segment => {
					let ineligible = false;
					if (!this.ancillariesService.INDRA_isCurrentPurchasedAncillariesEligible(this.flight.idFlight.toString(),
						segment.idInfoSegment.toString(),
						pax.idPax.toString(),
						PURCHASED_ANCILLARY_SEAT.ineligibleSSR)) {
						ineligible = true;
					}

					if (ineligible) {
						ineligibleSegmentCount++;
					}
				});

				if (this.interlineFlights.listSegment.length === ineligibleSegmentCount) {
					ineligibleForSeatSelection = true;
				}
			} else {
				ineligibleForSeatSelection = true;
			}

			if (ineligibleForSeatSelection) {
				ineligibleOnSeatSelectionCount++;
			}
		});

		// select seat button will be hidden only if all passengers are ineligible for seat selection..
		if (ineligibleOnSeatSelectionCount === this.passengers.length) {
			this._hasEdit = false;
		}

		this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(
			data => {
				if (data) {
					this.isFlagged = this.bookingService.INDRA_isUnavailableFlight(this.flight.idFlight, data);
				}
			}
		);

	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_getUniqueSeatDetails(flightIdentifier : string) {
		const journeySeatDetails = this.seats;
		let flightId = Number(flightIdentifier);
		
		if (journeySeatDetails[0][flightId] && journeySeatDetails[0][flightId].length) {
			journeySeatDetails[0][flightId].forEach(ancInfo => this.seatTypesToShow.push(ancInfo.seats))
			const arr =
				_.uniqWith(this.seatTypesToShow, (obj1, obj2) => Object.is(obj1.seatType, obj2.seatType)).sort(seat => seat.priority);
			return arr;
		} else {
			return [];
		}
		
	}

	INDRA_getTitleForType(ancInfo : INDRAAncillaryInfo){
		if (ancInfo && ancInfo.seatType) {
			return this.INDRA_getTitleByType(ancInfo.seatType);
		}
	}


	INDRA_getSeatAreaTypeForType(ancInfo : INDRAAncillaryInfo){
		return this.INDRA_getSeatAreaTypeByType();
	}

	INDRA_populateSeatPerSegment(idPax, segmentId) {
		idPax = idPax.toString();
		segmentId = segmentId.toString();
		let paxSeat: any = this.INDRA_getSeatsForPassenger(this.seats, idPax);
		let seatAssignment = '';
		paxSeat.forEach(data => {
			if (data.segmentId == segmentId && data.idPax == idPax) {
				if (!seatAssignment) {
					seatAssignment = data.seats.seatCode;
				}
				else {
					seatAssignment += ', ' + data.seats.seatCode;
				}
			}
		});
		return seatAssignment;
	}
	INDRA_isSeatSegmentConfirmed(idPax, segmentId) {
		idPax = idPax.toString();
		segmentId = segmentId.toString();
		let paxSeat: any = this.INDRA_getSeatsForPassenger(this.seats, idPax);
		let confirmed = true;
		paxSeat.forEach(data => {
			if (data.segmentId == segmentId && data.idPax == idPax) {
				const status = Number(data.seats.status);
				if (confirmed && UNCONFIRMED_CODES.includes(status)) {
					confirmed = false;
				}
			}
		});
		return confirmed;
	}
	INDRA_displaySegmentInfo(segmentId: string) {
		let returnValue = '';
		if (this.hasLayover) {
			let segmentInfo: INDRASegment = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
			let segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
			let segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
			returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
		}
		return returnValue;
	}

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	moveToSeatsSidebar() {
		this.sidebarService.openSidebar(['seatmap', { flight: this.flightIdentifier }]);
	}

	INDRA_openSlideshow() {
		const listSegmentElement = this.flightWithSegmentsOperatedByTAP.listSegment[0];
		const durationInHours = Math.floor(listSegmentElement.duration / 60);
		this.galleryImages = this.bookingService.INDRA_getSeatImages(this.seatType, listSegmentElement.equipment, durationInHours);
		this.modalService.assignComponent(
			INDRASlideshowComponent,
			this.galleryImages
		);
		this.modalService.open();
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }

	// SIDEBAR INTERACTIONS

	INDRA_getGroupLabel() {
		let groupList: string[] = ANCILLARY_GROUP_SEAT_RESERVATION_LIST;
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_GROUP + groupList[0]}`);
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
	}

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}
	
	/*
	INDRA_printBrand() {
		return this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
	}
	*/

	INDRA_getSeatsForPassenger(list: any, idPax: number) {
		let returnValue = "";
		const index = list.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list && index >= 0) {
			let paxAncillary = list[index];
			returnValue = paxAncillary[idPax];
		}
		return returnValue;
	}

	// SIDEBAR INTERACTIONS

	INDRA_showUpgrade() {
		// let brand = this.INDRA_printBrand();
		return !(this.brand === BRAND_CODE_TOP_EXECUTIVE || this.brand === BRAND_CODE_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren || !this.hasIssuedTicket) && !this.isFlagged;
	}

	INDRA_getTitleTranslation(lastKey: string, keyType: string) {
		const key = this.LOCAL_TRANSLATION_DETAILED_SEAT + keyType + "." + lastKey;
		return this.INDRA_getTranslation(key);
	}

	INDRA_getTranslationKey(lastKey: string, keyType: string) {
		return this.LOCAL_TRANSLATION_DETAILED_SEAT + keyType + "." + lastKey;
	}

	INDRA_checkIndirectFlight() {
		const segments: string[] = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
		let flag = false;
		if (segments.length > 1) {
			flag = true;
		}
		return flag;
	}

	INDRA_upgradeWithCash() {
		let activeBookedTrip = this.bfmDataStorage.INDRA_getActiveBookedTrip();
		let link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
		let params = { flight: this.flight.assignedFlightId }
		this.sidebarService.closeSidebar();
		this.bookingService.INDRA_linkRouteData(link, params);
	}

	INDRA_getTitle() {
		let key = 'seatingInStandardArea';

		switch (this.seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'seatingInExecutiveArea';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'seatingInPreferredArea';
				break;
			default:
				key = 'seatingInStandardArea';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'title');
	}

	INDRA_getTitleByType(seatType : string) {
		let key = 'seatingInStandardArea';
		switch (seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'seatingInExecutiveArea';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'seatingInPreferredArea';
				break;
			default:
				key = 'seatingInStandardArea';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'title');
	}

	INDRA_getSeatAreaTypeByType() {
		let key = 'standardArea';
		switch (this.seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'seatingInExecutiveArea';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'seatingInPreferredArea';
				break;
			default:
				key = 'standardArea';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'text');
	}






	INDRA_getSeatsDescriptionByType(seatType : string) {
		let key = 'standardSeatDescription';
		switch (seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'executiveSeatDescription';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'preferredSeatDescription';
				break;
			default:
				key = 'standardSeatDescription';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'text');
	}

	INDRA_getSeatsDescriptionForType(ancInfo : INDRAAncillaryInfo) {
		let key = 'standardSeatDescription';
		if(ancInfo && ancInfo.seatType) {
			switch (ancInfo.seatType) {
				case SEATMAP_SEAT_TYPE_BUSINESS:
					key = 'executiveSeatDescription';
					break;
				case SEATMAP_SEAT_TYPE_PREFERED:
					key = 'preferredSeatDescription';
					break;
				default:
					key = 'standardSeatDescription';
					break;
			}
		}
		return this.INDRA_getTranslationKey(key, 'text');
	}






	INDRA_showSeatPhotosByType(ancInfo : INDRAAncillaryInfo){
		let flag = false;
		const listSegmentElement = this.flightWithSegmentsOperatedByTAP.listSegment[0];
		const durationInHours = Math.floor(listSegmentElement.duration / 60);
		if(ancInfo && ancInfo.seatType) {
			let seatImages: AssetInfo[] = this.bookingService.INDRA_getSeatImages(ancInfo.seatType, listSegmentElement.equipment, durationInHours);
			if (seatImages.length > 0) {
				flag = true;
			}
		}
		return flag;
	}

	INDRA_openSlideshowByType(ancInfo : INDRAAncillaryInfo) {
		const listSegmentElement = this.flightWithSegmentsOperatedByTAP.listSegment[0];
		const durationInHours = Math.floor(listSegmentElement.duration / 60);
		this.galleryImages = this.bookingService.INDRA_getSeatImages(ancInfo.seatType, listSegmentElement.equipment, durationInHours);
		this.modalService.assignComponent(
			INDRASlideshowComponent,
			this.galleryImages
		);
		this.modalService.open();
	}

	INDRA_getSeatAreaType() {
		let key = 'standardArea';
		switch (this.seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'seatingInExecutiveArea';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'seatingInPreferredArea';
				break;
			default:
				key = 'standardArea';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'text');
	}

	INDRA_getSeatsDescription() {
		let key = 'standardSeatDescription';
		switch (this.seatType) {
			case SEATMAP_SEAT_TYPE_BUSINESS:
				key = 'executiveSeatDescription';
				break;
			case SEATMAP_SEAT_TYPE_PREFERED:
				key = 'preferredSeatDescription';
				break;
			default:
				key = 'standardSeatDescription';
				break;
		}
		return this.INDRA_getTranslationKey(key, 'text');
	}

	ngOnDestroy() {
		if (this.totalSummarySubscription) this.totalSummarySubscription.unsubscribe();
	}

	INDRA_showSeatPhotos() {
		let flag = true;
		const listSegmentElement = this.flightWithSegmentsOperatedByTAP.listSegment[0];
		const durationInHours = Math.floor(listSegmentElement.duration / 60);
		let seatImages: AssetInfo[] = this.bookingService.INDRA_getSeatImages(this.seatType, listSegmentElement.equipment, durationInHours);
		if (seatImages.length === 0) {
			flag = false;
		}
		return flag;
	}

	INDRA_getBrand() {
		if (!this.flight.fareFamily) {
			return '';
		} else {
			return (this.isBookingView || this.isReviewTTTCompletion) ? this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily) :
				this.bookingService.INDRA_getBrandCode(this.flight.fareFamily);
		}
	}
	
	INDRA_printImage() {
		let IMAGE = 'free_seat_reservation.jpg';
		if (this.flight['options']) {
			IMAGE = (this.flight.options.brand === 'executive' || this.flight.options.brand === 'top-executive' || this.flight.options.brand === 'miles&go-executive') ? 'executive_seat.jpg' : 'free_seat_reservation.jpg';
		} else if (this.flight['cabin']) {
			IMAGE = this.flight.cabin === 'Business' ? 'executive_seat.jpg' : 'free_seat_reservation.jpg';
		}
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}
}
